<template>
  <div>
    <div v-if="generatedCatalogData || errorPassed">
      <div v-if="this.errorPassed">
        <div v-if="this.errorPassed === 'NoArticlesFromSourceInCatalog'">
          {{ errors.NoArticlesInSourceCatalogue }}
        </div>
        <div v-if="this.errorPassed === 'CatalogNameExist'">
          <h3>{{ errors.CatalogueNameExist.title }}</h3>
          <p>{{ errors.CatalogueNameExist.message }}</p>
        </div>
      </div>
      <div v-else>
        <div class="mb-1">
          <div class="font-weight-bold">
            {{ $t("GenerateCatalogFromTextFile.CatalogFinishing.SelectedCatalogue") }}
          </div>
          <div>{{ generatedCatalogData.articlesInSourceCatalog }}</div>
        </div>
        <div class="mb-1">
          <div class="font-weight-bold">
            {{ $t("GenerateCatalogFromTextFile.CatalogFinishing.Source") }}
          </div>
          <div>{{ generatedCatalogData.articlesInSource }}</div>
        </div>
        <div class="mb-1">
          <div class="font-weight-bold">
            {{ $t("GenerateCatalogFromTextFile.CatalogFinishing.GeneratedCatalogue") }}
          </div>
          <div>{{ generatedCatalogData.articlesInCatalog }}</div>
        </div>
        <div class="my-3 d-flex" v-if="generatedCatalogData.nonExistingArticles.length > 0">
          <div>
            {{ $t("GenerateCatalogFromTextFile.CatalogFinishing.SaveText") }}
          </div>
          <b-btn class="ml-3" @click="downloadCsv"> {{ $t("Save") }} </b-btn>
        </div>
        <div>
          <b-checkbox v-model="openGeneratedCatalogue">{{ $t("OpenGeneratedCatalogue") }}</b-checkbox>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="mt-3 text-center">
        {{ $t("CatalogGenerationInProgress") }}
      </div>
      <div class="mb-3 mt-1">
        <spinner-vue></spinner-vue>
      </div>
    </div>
    <div class="catalog-modal-buttons">
      <b-btn @click="finish">{{ $t("Close") }}</b-btn>
    </div>
  </div>
</template>

<script>
import SpinnerVue from "../../../../common/components/Spinner.vue";

import { mapActions, mapMutations } from "vuex";

export default {
  props: ["generatedCatalogData", "newCatalogName", "errorPassed", "existingCatalogName"],
  components: { SpinnerVue },
  data() {
    return {
      openGeneratedCatalogue: false,
      errors: {
        NoArticlesInSourceCatalogue:
          this.$t("ErrorMessage.NoArticlesInSourceCatalogue") + "\n'" + this.existingCatalogName + "'. " + this.$t("ErrorMessage.NoCatalogueGenerated"),
        CatalogueNameExist: {
          title: this.$t("ErrorMessage.CatalogueGenerationFailed"),
          message: this.$t("ErrorMessage.CatalogueNameExist")
        }
      }
    };
  },
  methods: {
    ...mapActions({
      updateTargetCatalog: "channelCreator/updateTargetCatalog",
      reloadCatalogs: "channelCreator/loadCatalogs"
    }),
    ...mapActions(["saveUserSettings"]),
    ...mapMutations("channelCreator", {
      channelCreatorClearDirtyStatus: "clearDirtyStatus"
    }),
    ...mapMutations("contentEditor/catalogNode", {
      targetNodeClearDirtyStatus: "clear-dirty-status"
    }),

    downloadCsv() {
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += "ArticleNo\n";

      this.generatedCatalogData.nonExistingArticles.forEach((value) => {
        csvContent += value + "\n";
      });

      //This part is needed, so we can name the File. wouldnt be posible with window.open()
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", this.newCatalogName);
      document.body.appendChild(link);
      link.click();
    },

    finish() {
      this.$emit("finish");
      if (this.openGeneratedCatalogue) {
        this.reloadCatalogs().then(() => {
          //Timeout prevents JStree bug from loading it twice.
          setTimeout(() => {
            const catalogId = this.generatedCatalogData.catalogId;
            this.updateTargetCatalog(catalogId);
            this.saveUserSettings({ ChannelCreatorTargetCatalogId: catalogId });
            this.channelCreatorClearDirtyStatus();
            this.targetNodeClearDirtyStatus();
          }, 100);
        });
      } else {
        this.reloadCatalogs();
      }
      this.$root.$emit("bv::hide::modal", "from-text-file-modal");
    }
  }
};
</script>
